import { SepaScheme, TransactionType } from '@shared/transactions-types';
import type { DeepPartial } from '@luna/utils-ts';
import type { ExportFeatureConfig, TransactionsFeatureConfig } from '@shared/transactions-config';
import { isFeatureEnabled } from '@luna/gatekeeper';

const shouldShowFavoriteField = (): boolean => isFeatureEnabled((f) => f.transactions.favorites);

export const transactions: DeepPartial<TransactionsFeatureConfig> = {
    showReceiverAddress: true,
    showSenderAddress: true,
    showReceiverName: true,
    showExecutionTimeForTransactionTypes: [
        TransactionType.INSTANT_PAYMENT,
        TransactionType.POS_PAYMENT,
        TransactionType.MOBILE_PAYMENT,
        TransactionType.ATM,
    ],
    showExecutionTimeForSepaSchemes: [SepaScheme.INSTANT_PAYMENT],
    showBookingTypeForTransactionTypes: [
        TransactionType.MANUAL,
        TransactionType.STANDINGORDER,
        TransactionType.CREDIT_CARD_COLLECTION,
        TransactionType.CASH_COLLECTION,
    ],
    postalConfirmation: {
        handover: {
            targetClientId: 'gstore',
        },
    },
};

export const exportFeatures: DeepPartial<ExportFeatureConfig> = {
    lastExportOption: true,
    fields: [
        { name: 'ownerAccountTitle', preselected: true, selectable: true },
        { name: 'ownerAccountNumber', preselected: true, selectable: true },
        { name: 'booking', preselected: true, selectable: true },
        { name: 'amount', preselected: true, selectable: true },
        { name: 'currency', preselected: true, selectable: true },
        { name: 'receiver', preselected: true, selectable: true },
        { name: 'reference', preselected: true, selectable: true },
        { name: 'referenceNumber', preselected: true, selectable: true },
        { name: 'loanReference', preselected: false, selectable: true },
        { name: 'senderReference', preselected: false, selectable: true },
        { name: 'senderAddress', preselected: false, selectable: true },
        { name: 'receiverAddress', preselected: false, selectable: true },
        { name: 'note', preselected: false, selectable: true },
        {
            name: 'favorite',
            condition: shouldShowFavoriteField,
            preselected: false,
            selectable: true,
        },
        { name: 'valuation', preselected: false, selectable: true },
        { name: 'transactionDateTime', preselected: true, selectable: true },
        { name: 'category', preselected: false, selectable: true },
        { name: 'cardNumber', preselected: false, selectable: true },
        { name: 'cardLocation', preselected: false, selectable: true },
        { name: 'paymentMethod', preselected: false, selectable: true },
        { name: 'cardType', preselected: false, selectable: true },
        { name: 'cardBrand', preselected: false, selectable: true },
        { name: 'virtualCardNumber', preselected: false, selectable: true },
        {
            name: 'virtualCardMobilePaymentApplicationName',
            preselected: false,
            selectable: true,
        },
        { name: 'bookingTypeTranslation', preselected: false, selectable: true },
        { name: 'balance', preselected: false, selectable: true },
    ],
    sortParams: ['BOOKING_DATE_ASC', 'BOOKING_DATE_DESC', 'AMOUNT_ASC', 'AMOUNT_DESC'],
};
